import React, { FC } from 'react';
import { Affix } from 'antd';

import { DataTypeIcon, ObjectInfo } from '../../../common/components';
import { OBJECTDETAILPAGE_OBJECTTYPE } from '../../../common/components/ObjectDetailPage/ObjectDetailPage';

interface OwnProps {
  record: any;
  index: number;
  fixedComponent?: boolean;
  hideFilter?: boolean;
  hideSearch?: boolean;
}

export const renderVariableColumn = (
  record: any,
  fixedComponent?: boolean,
  hideFilter?: boolean,
  hideSearch?: boolean,
) => {
  const comp = (
    <ObjectInfo
      objectType={OBJECTDETAILPAGE_OBJECTTYPE.VARIABLE}
      icon={<DataTypeIcon dataType={record?.type} />}
      name={record.name}
      type={record.type}
      description={record.description}
      nameShowTooltipWithChildren={false}
    />
  );

  if (!fixedComponent) return comp;

  let offsetTop: number = 314;

  if (hideFilter && hideSearch) offsetTop -= 58;

  return (
    <Affix
      target={() => document.getElementById('variables-search-card-wrapper')}
      offsetTop={offsetTop}
    >
      {comp}
    </Affix>
  );
};

const VariablesSearchVariableColumn: FC<OwnProps> = ({
  record,
  index,
  fixedComponent = false,
  hideFilter,
  hideSearch,
}) => {
  return (
    <th key={`row-${index}-cell-0`}>
      {renderVariableColumn(record, fixedComponent, hideFilter, hideSearch)}
    </th>
  );
};

export default VariablesSearchVariableColumn;
